import "./App.css";
import Page from "./components/Page/Page";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import CurrentUserContext from "./contexts/CurrentUserContext";
import { Route, Routes } from "react-router-dom";
import { useState, useEffect } from "react";

import {
  NAME_3_THINGS_TITLE,
  YOUR_FAVOURITE_TITLE,
  CARDS_NAME_3_THINGS,
  FAVS,
} from "./utils/constants";
import Menu from "./components/Menu/Menu";
import Puzzle from "./components/Puzzle/Puzzle";
import Guess from "./components/Guess/Guess";
import Hangman from "./components/Hangman/Hangman";
import Memarts from "./components/Memarts/Memarts";
import Login from "./components/Login/Login";
import Register from "./components/Login/Register";
import { useNavigate } from "react-router-dom";

import api from "./utils/api";
import Dashboard from "./components/Dashboard/Dashboard";
import Phonetics from "./components/Phonetics/Phonetics";

function App() {
  const [isDark, setIsDark] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return savedTheme === "dark";
  });

  const [successState, setSuccessState] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Add loading state
  const [loggedIn, setLoggedIn] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [currentUser, setCurrentUser] = useState({
    id: "",
    name: "Загрузка...",
    email: "Загрузка...",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const jwt = localStorage.getItem("jwt");
    if (jwt) {
      tokenCheck(jwt);
    } else {
      setIsLoading(false); // No token, stop loading
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("theme", isDark ? "dark" : "light");
  }, [isDark]);

  const handleLogout = () => {
    localStorage.removeItem("jwt");
    setLoggedIn(false);
    setEmail("");
    setName("");
    setCurrentUser("");
  };

  const tokenCheck = (jwt) => {
    // console.log(jwt);
    api
      .tokenCheck(jwt)
      .then((res) => {
        api.setHeaders(jwt);
        setEmail(res.email);
        setName(res.fullName);
        setCurrentUser(res);
        setLoggedIn(true);
        // navigate("/memarts");
        // return true;
      })
      .catch((err) => {
        if (err.status === 401) {
          console.log("Переданный токен некорректен. Ошибка: " + err.status);
          localStorage.removeItem("jwt"); // Clear invalid token
        }
      })
      .finally(() => {
        setIsLoading(false); // Always stop loading
      });
  };

  const handleLogin = (email, password) => {
    // Changed order
    return api
      .loginUser(email, password) // Changed order
      .then((data) => {
        if (data.token) {
          localStorage.setItem("jwt", `Bearer ${data.token}`);
          api.setHeaders(`Bearer ${data.token}`);
          setEmail(email);
          setName(data.fullName);
          setLoggedIn(true);
          return data; // Return data so navigation can happen after
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          console.log("Пользователь с таким e-mail не найден");
        } else if (err.status === 400) {
          console.log("Не передано одно из полей");
        } else {
          console.log("Неизвестная ошибка: " + err.status);
        }
        throw err; // Re-throw to handle in component
      });
  };
  const handleRegister = (fullName, email, password) => {
    return api
      .registerUser(fullName, email, password)
      .then((data) => {
        console.log(data);
        if (data.message) {
          setSuccessState(false);
          return;
        } else {
          setSuccessState(true);
        }

        return data;
      })
      .catch((err) => {
        setSuccessState(false);
        if (err.status === 400) {
          console.log("Некорректно заполнено одно из полей ");
        } else {
          console.log("Неизвестная ошибка: " + err.status);
        }
      });
  };

  useEffect(() => {
    if (loggedIn === true) {
      api
        .getUserInfo()
        .then((user) => {
          setCurrentUser(user);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [loggedIn]);

  if (isLoading) {
    return <div className='loading'>Loading...</div>; // Or your loading component
  }

  return (
    <CurrentUserContext.Provider value={currentUser}>
      <div className={`App ${isDark ? "dark" : ""}`}>
        <Menu
          loggedIn={loggedIn}
          isDark={isDark}
          setIsDark={setIsDark}
          onLogout={handleLogout}
        />
        <div className={`Page ${isDark ? "dark" : ""}`}>
          <Routes>
            <Route
              path='/login'
              element={<Login onLogin={handleLogin} loggedIn={loggedIn} />}
            />
            <Route
              path='/register'
              element={
                <Register
                  onRegister={handleRegister}
                  onLogin={handleLogin}
                  loggedIn={loggedIn}
                />
              }
            />

            <Route
              exact
              path='/'
              element={
                <Memarts
                  isDark={isDark}
                  loggedIn={loggedIn}
                  setIsDark={setIsDark}
                />
              }
            />
            <Route
              path='/namethings'
              element={
                <Page
                  title={NAME_3_THINGS_TITLE}
                  list={CARDS_NAME_3_THINGS}
                  // isDark={isDark}
                  // setIsDark={setIsDark}
                />
              }
            />
            <Route
              path='/favs'
              element={<Page title={YOUR_FAVOURITE_TITLE} list={FAVS} />}
            />
            <Route path='/puzzles' element={<Puzzle />} />
            <Route path='/guess' loggedIn={loggedIn} element={<Guess />} />
            <Route path='/hangman' element={<Hangman />} />
            <Route
              path='/dashboard'
              element={
                <ProtectedRoute
                  loggedIn={loggedIn}
                  element={Dashboard}
                  onLogout={handleLogout}
                />
              }
            />

            <Route
              path='/phonetics'
              element={
                <ProtectedRoute loggedIn={loggedIn} element={Phonetics} />
              }
            />
            <Route
              path='/memarts'
              element={<Memarts isDark={isDark} setIsDark={setIsDark} />}
            />
          </Routes>
        </div>
      </div>
    </CurrentUserContext.Provider>
  );
}

export default App;
